import { useEffect } from "react";
import AppRoutes from "./routes/AppRoutes";
import { useLocalization } from "./stores/localizationContext.tsx";
import { UserProvider } from "./stores/userContext";
function App() {
  const { t, lang } = useLocalization();

  useEffect(() => {
    document.title = t("app_name_label");
  }, [t, lang]);
  return (
    <UserProvider>
      <AppRoutes />
    </UserProvider>
  );
}

export default App;
